import { media, redOrGreen, COLORS } from '../../utils/style-utils';
import styled from 'styled-components';

export const CalculationInput = styled.input`
  padding: 5px;
  display: flex;
  width: 100%;
  border: 3px solid #fff;
  border-radius: 3px;
  font-size: 16px;
  color: #111;
`;

export const CurrencyLabel = styled.span`
  font-size: 20px;
  display: inline-block;
  margin-right: 10px;
  color: #fff;
  width: 50px;
`;

export const ControlsContainer = styled.div`
  display: flex;
`;

export const QuoteCurrencyOutput = styled.span`
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #fff;
  padding-bottom: 2px;
  display: flex;
  width: 100%;
`;

export const CurrencyTable = styled.table`
  margin: 0 auto;
  border: solid 1px ${COLORS.DARK_BLUE} !important;
  border-left: none;
  border-right: none;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  max-width: 540px;

  & tbody td {
    border: solid 1px ${COLORS.DARK_BLUE} !important;
    color: ${COLORS.DARK_BLUE};
    padding: 10px !important;
    text-align: center;
  }
`;

export const Button = styled.button`
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  font-family: Arial;
  color: #ffffff;
  font-size: 18px;
  background: #5b86a3;
  padding: 8px 20px 8px 20px;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background: #8ab2cc;
    text-decoration: none;
  }
`;

export const FreeTextSearchInput = styled.input`
  border: 3px solid #eee;
  margin: 0 20px 0 0;
  padding: 8px 10px;
  width: 220px;
  font-size: 16px;
  ${media.handheld`
  margin 0 0 10px 0;
`};
`;

export const MobileLabel = styled.span`
  display: none;
  ${media.handheld`
  flex-direction: column;
  align-items: left;
  `};
`;

export const CurrencyTableContainer = styled.div`
  padding: 0;
  max-width: 600px;
  margin: 40px auto;
`;
export const List = styled.ul`
  margin: 0;
  padding: 0 !important;
`;

export const ListItem = styled.li`
  background-color: #fff;
  padding: 5px;
  margin: 5px 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${media.handheld`
  flex-direction: column;
  align-items: left;
`};
`;

export const ListHeader = styled.li`
  background-color: #4cb4a4;
  color: #fff;
  font-weight: bold;
  padding: 5px;
  margin: 5px 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ListItemValue = styled.span`
  margin: 0 5px;
  width: 160px;
  align-items: center;
  display: inline-block;
  ${media.handheld`

`};
`;

export const ListItemHeaderValue = styled.span`
  cursor: pointer;
  margin: 0 5px;
  width: 160px;
  align-items: center;
  display: inline-block;
  ${media.handheld`

`};
`;

export const ListItemHeader = styled.span`
  margin: 0 5px;
  width: 160px;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px;
  border-radius: 3px;
  background-color: ${COLORS.EMERALD_GREEN} ${media.handheld`
  flex-direction: column;
`};
`;

export const sortOptions = {
  isDescending: true,
  values: {
    MARKET_CAP: 'market_cap_usd',
    SUPPLY: 'total_supply',
    PRICE: 'price_usd',
    CHANGE_1H: 'percent_change_1h',
    CHANGE_24H: 'percent_change_24h',
    CHANGE_7D: 'percent_change_7d',
  },
};
